import React, { useEffect, useState } from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { ListChecks, CheckCircle2, Loader2 } from 'lucide-react';
import { coachAPI, mediaUrl } from '../services/api';

const Section = ({ title, rows }) => (
  <div>
    <div className="flex items-center justify-between mb-2">
      <h4 className="text-sm font-bold text-foreground">{title}</h4>
      <span className="text-xs text-muted-foreground">{rows.filter((r) => r.all_done).length}/{rows.length} complets</span>
    </div>
    {rows.length === 0 ? (
      <p className="text-xs text-muted-foreground py-2">Aucun membre dans ce profil.</p>
    ) : (
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.user_id} data-testid={`coach-routine-${r.user_id}`} className="flex items-center gap-3 p-2.5 rounded-xl border border-border">
            <Avatar className="w-8 h-8"><AvatarImage src={mediaUrl(r.avatar)} /><AvatarFallback className="bg-orange-500 text-white text-xs">{r.name?.charAt(0)}</AvatarFallback></Avatar>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-foreground truncate">{r.name}</p>
              <div className="h-1.5 rounded-full bg-muted mt-1 overflow-hidden">
                <div className={`h-full rounded-full ${r.all_done ? 'bg-green-500' : 'bg-orange-500'}`} style={{ width: `${r.total ? (r.validated_count / r.total) * 100 : 0}%` }} />
              </div>
            </div>
            {r.all_done ? (
              <Badge className="bg-green-600 text-white border-0 text-[10px]"><CheckCircle2 className="w-3 h-3 mr-1" />Complet</Badge>
            ) : (
              <span className="text-xs font-bold text-muted-foreground w-10 text-right">{r.validated_count}/{r.total}</span>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
);

export const CoachRoutines = () => {
  const [data, setData] = useState(null);

  useEffect(() => { coachAPI.routines().then(setData).catch(() => {}); }, []);

  if (!data) return <Card className="p-5 rounded-2xl border-red-100 dark:border-red-900/50"><Loader2 className="w-5 h-5 animate-spin text-orange-500 mx-auto" /></Card>;

  return (
    <Card className="p-5 rounded-2xl border-red-100 dark:border-red-900/50" data-testid="coach-routines">
      <h3 className="font-bold text-red-950 dark:text-red-50 mb-1 flex items-center gap-2"><ListChecks className="w-5 h-5 text-orange-500" />Routines du jour</h3>
      <p className="text-xs text-muted-foreground mb-4">Qui a complété ses routines aujourd'hui, par profil.</p>
      <div className="space-y-5">
        <Section title="Clients" rows={data.client} />
        <Section title="Distributeurs" rows={data.distributeur} />
      </div>
    </Card>
  );
};
